import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';

import { QueryClient, QueryClientProvider } from "react-query";
const queryClient = new QueryClient({queries: { staleTime: 4000, refetchOnWindowFocus: false, }});

const root = ReactDOM.createRoot(document.getElementById('root'));



import "./main/i18n";

root.render(
  <GoogleOAuthProvider clientId="849400142414-lvl7uo30gpftgo93er74n9ro7irbhi58.apps.googleusercontent.com">
    <React.StrictMode>

      <QueryClientProvider client={queryClient}>
        <BrowserRouter >
          <App />
        </BrowserRouter>
      </QueryClientProvider>
      
    </React.StrictMode>
  </GoogleOAuthProvider>
);


reportWebVitals();
